import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import useUserSession from '@medflex/hooks/useUserSession';
import useUserProfile from '../../hooks/useUserProfile';
import useAddressBookContacts from '../../hooks/useAddressBookContacts';
import ActivitiesPamChat from './ActivitiesPamChat';

// eslint-disable-next-line import/no-unresolved
const RemoteActivitiesApp = React.lazy(() => import('RemoteActivities/Activities'));

const getActivitiesUsers = (physicianUserId, { patientUserId, pvsId }) => [
  {
    id: physicianUserId,
    type: 'physician',
  },
  {
    id: patientUserId,
    type: 'patient',
    pvsId,
  },
];

const ActivitiesModule = () => {
  const { contactId } = useParams();
  const { session } = useUserSession();
  const { userProfile } = useUserProfile();
  const { findOneAddressBookContactByContactId } = useAddressBookContacts();
  const contact = findOneAddressBookContactByContactId(contactId);
  const renderChat = useCallback(({ id }) => <ActivitiesPamChat id={id} />, []);

  if (!contact) return null;

  const users = getActivitiesUsers(userProfile.attributes.physicianUserId || userProfile.id, {
    patientUserId: contact.user.id,
    pvsId: contact.pvsId,
  });

  return <RemoteActivitiesApp token={session.access_token} users={users} renderChat={renderChat} />;
};

export default ActivitiesModule;
